import { engineComponent } from "neo-common";
import { Reel } from "./Reel";
import { ComponentTypes } from "../Components/ComponentTypes";

@engineComponent(ComponentTypes.DisplayObject)
export class Reel2 extends Reel {
    //******************************************************************************************************************
    //  SPIN START
    //******************************************************************************************************************

    public spinStart(delay?: number): void {
        this.shouldBeStopping = false;
        this.isStopping = false;
        this.stoppingCounter = 0;
        this.isTeasing = false;
        this.teasingSymbols = [];
        this.rollSpeed = this.speed;
        this.stripIndex = (this.data.index - this.symbolTopCount + this.strip.length) % this.strip.length;

        if (delay > 0) {
            setTimeout(() => {
                this.spinPreRoll();
            }, delay);
        } else {
            this.spinPreRoll();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Reel2.ts
 **/